import { usersApi } from './users/users.api'
//TODO deprecated
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { layersApi } from './layers/layers.api'
import { layersReducer } from './layers/layers.slice'
import { categoriesApi } from './categories/categories.api'
import { categoriesReducer } from './categories/categories.slice'
import { locationsApi } from './locations/locations.api'
import { locationsReducer } from './locations/locations.slice'
import { pointsApi } from './points/points.api'
import { pointsReducer } from './points/points.slice'
import { eventsApi } from './events/events.api'
import { eventsReducer } from './events/events.slice'
import { reviewsApi } from './reviews/reviews.api'
import { appReducer } from './app/app.slice'
import { usersReducer } from './users/users.slice'

export const store = configureStore({
  reducer: {
    [pointsApi.reducerPath]: pointsApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [layersApi.reducerPath]: layersApi.reducer,
    [categoriesApi.reducerPath]: categoriesApi.reducer,
    [locationsApi.reducerPath]: locationsApi.reducer,
    [reviewsApi.reducerPath]: reviewsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,

    layers: layersReducer,
    categories: categoriesReducer,
    points: pointsReducer,
    events: eventsReducer,
    app: appReducer,
    locations: locationsReducer,
    users: usersReducer,
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  })
    .concat(pointsApi.middleware)
    .concat(eventsApi.middleware)
    .concat(layersApi.middleware)
    .concat(categoriesApi.middleware)
    .concat(locationsApi.middleware)
    .concat(reviewsApi.middleware)
    .concat(usersApi.middleware),
})

export const {
  useGetPointQuery,
  useLazyGetPointQuery,
  usePostPointMutation,
  usePutPointMutation,
  useDeletePointMutation,
  useGetPointsMutation,
} = pointsApi

export const {
  useGetEventQuery,
  useLazyGetEventQuery,
  usePostEventMutation,
  usePutEventMutation,
  useDeleteEventMutation,
  useGetEventsMutation,
} = eventsApi

export const { useGetLayersQuery } = layersApi

export const { useGetCategoriesQuery } = categoriesApi

export const {
  useGetLocationsQuery,
  useLazyGetLocationsQuery,
  useGetLocationMutation,
} = locationsApi

export const {
  useGetPointReviewQuery,
  useGetLocationReviewQuery,
  usePostReviewMutation,
  usePutReviewMutation,
  useDeleteReviewMutation,
  useGetReviewQuery,
} = reviewsApi

export const { useGetUserQuery, useLogoutMutation } = usersApi

export type RootState = ReturnType<typeof store.getState>
